// Vue
import { Component, Watch, Vue, Prop } from "vue-property-decorator";
// Template
import template from "./template.vue";
// Base Module
import ModuleBase from "#/common/ModuleBase";
// Components
import { Observer } from "mobx-vue";
import { throttle } from "../../../common/Utils";
import { Api } from "../../../api";

@Observer
@Component({
  mixins: [template],
  components: {},
})
export class Searchbox extends Vue {
  @Prop()
  private points!: H.geo.IPoint[];

  @Prop()
  private selectedPoints!: H.geo.IPoint[];

  @Prop()
  private currentLocation!: H.geo.IPoint;

  @Prop()
  private selectedHaendler!: any;

  @Prop()
  private translation!: { [key: string]: string };

  @Prop({ default: true })
  public showBackLink!: boolean;

  private showError1: boolean = false;
  private showError2: boolean = false;
  private myLocation: H.geo.IPoint | null = null;
  private autoSuggestList: object[] = [];
  private searchInput: string = "";
  private onSearchInputThrottled = throttle(this.onSearchInput, 750);
  private showNearestPartner: boolean = false;

  private get mailLink() {
    if (
      this.selectedHaendler &&
      this.selectedHaendler.data &&
      this.selectedHaendler.data.contact &&
      this.selectedHaendler.data.contact.email
    ) {
      return "mailto:" + this.selectedHaendler.data.contact.email;
    } else {
      return "";
    }
  }

  private get isLocationActive() {
    return this.myLocation !== null;
  }

  private get isAutosuggestListVisible() {
    return this.autoSuggestList.length > 0;
  }

  private get hasSearchInput() {
    return this.searchInput.length > 0;
  }

  private get hasSelectedHaendler() {
    return this.selectedHaendler !== null;
  }

  private onCurrentLocationButtonClick(event) {
    this.showError1 = false;

    if (this.isLocationActive) {
      this.$emit("changeMyLocation", null);
      this.myLocation = null;
    } else {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          var point = new H.geo.Point(
            pos.coords.latitude,
            pos.coords.longitude
          );
          this.myLocation = point;
          this.$emit("changeMyLocation", point);
        },
        () => {
          this.$emit("changeMyLocation", null);
          this.myLocation = null;
          this.showError1 = true;
        }
      );
    }
  }

  private goBack(event) {
    event.preventDefault();
    window.history.back();
  }

  private onSearchInput(value) {
    this.showError1 = false;
    this.showError2 = false;
    if (value.length > 0) {
      Api.haendlersuche
        .autosuggest(value, this.currentLocation.lat, this.currentLocation.lng)
        .then((result) => {
          if (result && result.results && result.results.length > 0) {
            this.autoSuggestList = result.results;
          } else {
            this.showError2 = true;
            this.autoSuggestList = [];
          }
        });
    } else {
      this.autoSuggestList = [];
    }
  }

  private onClearSearchInput(event) {
    this.showError1 = false;
    this.showError2 = false;
    this.searchInput = "";
    this.autoSuggestList = [];
    this.myLocation = null;
    this.$emit("selectHaendler", null);
    this.$emit("changeMyLocation", null);
  }

  private onSuggestListItemClick(event, entry) {
    event.preventDefault();

    this.searchInput = entry.title;

    var point = new H.geo.Point(entry.position[0], entry.position[1]);
    this.myLocation = point;
    this.$emit("selectHaendler", null);
    this.$emit("changeMyLocation", point);
    this.autoSuggestList = [];
  }

  private onSelectHaendler(event, point) {
    event.preventDefault();
    this.$emit("selectHaendler", point);
  }

  private onBackClick(event) {
    event.preventDefault();
    this.$emit("selectHaendler", null);
  }

  private onShowNearestPartner(event) {
    this.showNearestPartner = true;
  }

  private onShowMap(event) {
    this.showNearestPartner = false;
  }
}
